import Vue from 'vue'
import Router from 'vue-router'
import Role from '../main/permission/Role.vue'
import DashBoard from '../main/home/Dashboard.vue'
import Login from '../main/system/Login.vue'
import MenuSlider from '../main/home/MenuSlider.vue'
import Resource from '../main/permission/Resource.vue'
import Admin from '../main/permission/Admin.vue'
//import Img from '../main/admin/Imgs.vue'
import TagList from '../main/admin/TagList.vue'
import ImgList from '../main/admin/ImgList.vue'
import WxUser from '../main/admin/WxUser'
import HomeTag from '../main/admin/HomeTag.vue'
import TwoTag from '../main/admin/TwoTag.vue'
import OneTag from '../main/admin/OneTag.vue'
import Style from '../main/admin/Style.vue'
import Color from '../main/admin/Color.vue'
import ImgList2 from '../main/admin/ImgList2.vue'
import Label from '../main/admin/Label.vue'
import Article from '../main/admin/Article.vue'

import ArticleAdd from '../main/admin/ArticleAdd.vue'
import OssUploadExample from '../common/OssUploadExample.vue'
import Banner from '../main/admin/Banner.vue'
import Gg from '../main/admin/Gg.vue'








Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: '',
      component: MenuSlider,
      children: [{
        path: '/ou',
        name: "OssUploadExample",
        component:OssUploadExample
      },
        {
          path: '/homes-tag',
          name: "HomeTag",
          component: HomeTag
        },
        {
          path: '/gg',
          name: "Gg",
          component: Gg
        },
        {
          
          path: '/one-tags',
          name: "OneTag",
          component: OneTag
        },
        {
          
          path: '/two-tags',
          name: "TwoTag",
          component: TwoTag
        },
        {
          
          path: '/banner',
          name: "Banner",
          component: Banner
        },
        {
          
          path: '/style',
          name: "Style",
          component: Style
        },
        {
          
          path: '/color',
          name: "Color",
          component: Color
        },
        {
          path:'/labels',
          name: "label",
          component:Label
        },
        {
          path:'/img-list2',
          component:ImgList2
        },
        {
          path:'/article',
          component:Article

        },
        {
          path:'/article-add',
          component:ArticleAdd
          
        },
        {
          path: '/',
          name: "DashBoard",
          component: DashBoard
        }, {
          path: '/role',
          name: 'Role',
          component: Role
        },
        {
          path: '/admins',
          name: 'Admin',
          component: Admin
        },
        {
          path: '/resources',
          name: 'Resource',
          component: Resource
        },
        {
          path:'/wx/user',
          name:'WxUser',
          component:WxUser
        },
        {
          path:'/img-list',
          component:ImgList
        },
        {
          path:'/tags',
          component:TagList
        }
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js